import fetch from 'src/http/fetch'

// 培训导师列表
export function partners () {
  return fetch('training/partners', {})
}



// WEBPACK FOOTER //
// ./src/api/trainingApi.js